import axios from 'axios';

const domain = (process.env.REACT_APP_DOMAIN || '').replace(/\/+$/, '');

const AxiosPost = async (path, params, contenType = 'application/json') => {
  const response = await axios.post(domain + path, params, {
    headers: {
      'Content-Type': contenType,
    },
    withCredentials: true,
  });
  return response.data;
};

const AxiosPut = async (path, params, contenType = 'application/json') => {
  const response = await axios.put(domain + path, params, {
    headers: {
      'Content-Type': contenType,
    },
    withCredentials: true,
  });
  return response.data;
};

const AxiosDelete = async (path, config = {}) => {
  const response = await axios.delete(domain + path, {
    withCredentials: true,
    ...config,
  });
  return response.data;
};

const AxiosGet = async (path, config = {}) => {
  const response = await axios.get(domain + path, {
    withCredentials: true,
    ...config,
  });
  return response.data;
};

export default AxiosPost;
export { AxiosDelete, AxiosGet, AxiosPost, AxiosPut };
